<template>
<div>
  <SearchBar placeholder="ค้นหาสัญญา" v-model="contractSearchString"></SearchBar>
  <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
  <div v-if="contractSearchString !== ''" class="container pl-4 pr-4 pt-1 pb-2 bg-white text-primary">
    พบ {{contracts.length}} สัญญา ที่มี "{{contractSearchString}}" ในประวัติสัญญา
  </div>
  <div class="container text-center">
    <div class="spinner-border text-primary text-center m-4" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="list-group list-group-flush">
      <button v-for="contract in contracts" :key="contract.id" class="list-group-item list-group-item-action p-4" @click="navigate(contract)">
          <div class="row">
              <div class="col-8">
                  <p v-if="contract.type === 'MONEY'" class="m-0">สัญญากู้เงิน #{{contract.contractNo}} ({{$contractStatusDict[contract.status]}})</p>
                  <p v-if="contract.type === 'THING'" class="m-0">สัญญาซื้อขาย #{{contract.contractNo}} ({{$contractStatusDict[contract.status]}})</p>
                  <p v-if="contract.type === 'MORTGAGE'" class="m-0">สัญญาสินเชื่อบ้าน #{{contract.contractNo}} ({{$contractStatusDict[contract.status]}})</p>
                  <p v-if="activeUserSide === 'HAIGOO'" class="m-0 text-secondary">
                    <small>{{contract.info.moneyPayload.korgoo.name}}</small>
                  </p>
                  <p v-if="activeUserSide === 'KORGOO'" class="m-0 text-secondary">
                    <small>{{contract.info.moneyPayload.haigoo.name}}</small>
                  </p>
              </div>
              <div class="col-4 text-right">
                  <p v-if="activeUserSide === 'KORGOO'" class="m-0 text-danger">{{contract.info.moneyPayload.amount | money}}</p>
                  <p v-if="activeUserSide === 'HAIGOO'" class="m-0 text-success">{{contract.info.moneyPayload.amount | money}}</p>
                  <p class="m-0 text-secondary"><small>{{$dayjs(contract.datetime).format('HH:mm D MMM YYYY')}}</small></p>
              </div>
          </div>
      </button>
  </div>
</div>
</template>

<script>
import SearchBar from '../../sub_components/SearchBar'

export default {
  data: () => ({
    isCantReach: false,
    errorData: {},
    isLoading: false,
    contractSearchString: '',
    contracts: [],
    contractsAll: [],
  }),
  async created () {
    await this.populateContracts()
  },
  watch: {
      contractSearchString (to) {
          if (to === '') {
              this.contracts = this.contractsAll
          } else {
              this.contracts = this.contractsAll.filter(
                  elm => (
                    elm.contractNo.toString().includes(to.toLowerCase()) ||
                    elm.info.moneyPayload.haigoo.name.toLowerCase().includes(to.toLowerCase()) ||
                    elm.info.moneyPayload.korgoo.name.toLowerCase().includes(to.toLowerCase())
                  )
              )
          }
      },
      activeUserSide () {
        this.populateContracts()
      }
  },
  methods: {
    navigate (contract) {
      this.$router.push({ name: 'transaction-contract-view', params: { id: contract.id } })
    },
    async populateContracts () {
      this.contracts = []
      this.isLoading = true
      const result = await this.$api.contract.listForPay()
      const data = result.data
      if (!data.success) {
        this.isCantReach = true
        this.errorData = data
        return
      }
      this.contractsAll = this.contractFilter(data.contracts, this.activeUserSide)
      this.contracts = this.contractsAll
      this.isLoading = false
    },
    contractFilter (contracts, activeUserSide) {      
      return contracts.filter((elm) => {
        console.log(elm)
        if (elm.activeUserSide === activeUserSide) return true
        return false
      })
    }
  },
  props: ['activeUserSide'],
  components: {
    SearchBar
  }
}
</script>

<style lang="scss">
</style>
